import { render, staticRenderFns } from "./JxcSetting.vue?vue&type=template&id=b210bf66&scoped=true"
import script from "./JxcSetting.vue?vue&type=script&lang=js"
export * from "./JxcSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b210bf66",
  null
  
)

export default component.exports